var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDocument(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 293,
    height: 293,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    overflow: "hidden",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 493,
    y: 213,
    width: 293,
    height: 293
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)",
    transform: "translate(-493 -213)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M748.184 268.967 696.283 216.054C694.367 214.101 691.74 213 689.003 213L606.743 213 598.516 213 538.09 213C532.462 213 527.898 217.564 527.898 223.187 527.898 228.81 532.462 233.374 538.09 233.374L598.516 233.374 606.743 233.374 678.816 233.374 678.821 277.582C678.821 283.21 683.38 287.773 689.008 287.773L730.717 287.773 730.717 485.626 549.563 485.626 549.563 260.803C549.563 255.175 544.999 250.612 539.371 250.612 533.743 250.612 529.184 255.175 529.184 260.803L529.184 495.813C529.184 501.441 533.748 506 539.371 506L740.909 506C746.537 506 751.101 501.436 751.101 495.813L751.101 276.104C751.096 273.436 750.052 270.873 748.184 268.967ZM699.201 267.395 699.201 248.129 718.097 267.395 699.201 267.395Z",
    fill: "#FFFFFF"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocument);
export default __webpack_public_path__ + "static/media/document.60f1f83f80a440a70aeedb5cffe3e32a.svg";
export { ForwardRef as ReactComponent };